import { useContext, useEffect, useState } from "react";
import Container from "../../../components/components-ui/Container/Container";
import DataTable from "react-data-table-component";
import styles from "./painellogistica.module.css";
import { Field, Form, Formik } from "formik";
import { Box } from "@mui/material";
import Button from "../../../components/components-ui/Button/Button";
import { Col, Grid } from "../../../components/Grid";
import api from "../../../services/Api";
import { Table } from "../../../components/Table";
import { toast } from "react-toastify";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import { SelectSearch } from "../../../components/components-ui/SelectSearch/SelectSearch";
import Loading from "../../../components/components-ui/Loading/Loading";
import Modal from "@mui/material/Modal";
import EditarFreguesia from "./EditarFreguesia/EditarFreguesia";
import AdicionarColeta from "./ModaisPainelLocais/ModalAdicionarColeta/AdicionarColeta";
import AdicionarFornecedor from "./ModaisPainelLocais/AdicionarFornecedor/AdicionarFornecedor";
import InputClear from "../../../components/components-ui/InputClear/InputClear";
import * as Sentry from "@sentry/react";
import AdicionarRecadoAFreguesia from "./ModaisPainelLocais/AdicionarRecadoAFreguesia/AdicionarRecadoAFreguesia";
import { confirmAlert } from "react-confirm-alert";
import CustomConfirmAlert from "../../../components/components-ui/CustomConfirmAlert/CustomConfirmAlert";
import RelatorioFreguesia from "./Relatorios/RelatorioFreguesia/RelatorioFreguesia";
import { useVerificaPermissao } from "../../../utils/verificaPermissao";
import { AuthContext } from "../../../Provider/AuthContext";
import { useOrdenacao } from "../../../utils/useOrdenacao";
import RelatorioColetas from "./Relatorios/RelatorioColetas/RelatorioColetas";

const API_VEICULOS = "/veiculo/index";
const API_STATUS = "/rotafreguesiastatus";
const API_PAINEL_FREGUESIA = "/painelfreguesia";
const LOCAIS_ROTA = "painelfreguesia/listaocsub?id_oc=";
const API_VIEW_EDIT = "/painelfreguesia/vieweditoc/";
const API_LISTA_COLETAS_OC = "/painelfreguesia/listarcoletasoc/";
const API_ENCERRAR_ROTA = "/freguesia/encerrarrota";
const API_CANCELAR_ROTA = "/freguesia/cancelarrota";
const API_REATIVAR_ROTA = "/freguesia/reativarrota/";
const API_RELATORIO_COLETAS = "/painelfreguesia/relatoriocoletas/";

const formatterNumber = (number) => {
  const formatted = new Intl.NumberFormat("pt-BR", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(number);

  return formatted;
};

const columnsFiltros = [
  {
    column: "Menu",
    key: "acoes",
  },
  {
    column: "Nº O.C.",
    key: "IDOC",
  },
  {
    column: "Freguesia",
    key: "Freguesia",
  },
  {
    column: "Veiculo",
    key: "Placa",
  },
  {
    column: "Data Freguesia",
    key: "DataProgramacao",
  },
  {
    column: "Status",
    key: "Status",
  },
];

const columnsPainelFreguesiaLocais = [
  {
    column: "Menu",
    key: "acoes",
  },
  {
    column: "Código",
    key: "Codigo",
  },
  // {
  //   column: "IdOCSub",
  // },
  // {
  //   column: "Id Local",
  // },
  {
    column: "Marca",
    key: "Marca",
  },
  {
    column: "Logradouro",
    key: "Logradouro",
  },
  {
    column: "R$ Kg.",
    key: "ValorKgContrapartida",
  },
  {
    column: "Qtd. Coletas",
    key: "QtdColetas",
  },
  {
    column: "Vol. Oleo",
    key: "SomaVolume",
  },
  {
    column: "Valor",
    key: "SomaPagamento",
  },
];

const columnsColetas = [
  {
    column: "Nº Coleta",
  },
  {
    column: "Recado",
  },
  {
    column: "Código",
  },
  {
    column: "Marca",
  },
  {
    column: "QTDE",
  },
  {
    column: "Forma de Pagamento",
  },
  {
    column: "Valor",
  },
];

const diaAtual = new Date().toISOString().split("T")[0];

function definirImpressaoPaisagem() {
  var style = document.createElement("style");
  style.innerHTML = "@media print { @page { size: landscape; } }";
  style.id = "impressao-orientacao";
  document.head.appendChild(style);
}

function definirImpressaoRetrato() {
  var style = document.createElement("style");
  style.innerHTML = "@media print { @page { size: portrait; } }";
  style.id = "impressao-orientacao";
  document.head.appendChild(style);
}

function PainelLogistica() {
  const { idTipoUsuario } = useContext(AuthContext);
  const verificaPermissao = useVerificaPermissao();

  const [dadosFreguesia, setDadosFreguesia] = useState([]);
  const [veiculos, setVeiculos] = useState([]);
  const [status, setStatus] = useState([]);
  const [dadosPainelFreguesia, setDadosPainelFreguesia] = useState([]);
  const [locaisDaRota, setLocaisDaRota] = useState([]);
  const [dataLocaisFiltrados, setDataLocaisFiltrados] = useState([]);
  const [listaColetasOc, setListaColetasOc] = useState([]);
  const [freguesia, setFreguesia] = useState("");
  const [numeroOc, setNumeroOc] = useState("");
  const [inputFilter, setInputFilter] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [filterTable, setFilterTable] = useState(
    `&data_freguesia_de=${diaAtual}&data_freguesia_ate=${diaAtual}`
  );
  const [loading, setLoading] = useState({
    loadingFreguesia: false,
    loadingLocais: false,
  });
  const [openModal, setOpenModal] = useState({
    adicionarColeta: false,
    editarOc: false,
    adicionarFornecedor: false,
    adicionarRecadoAFreguesia: false,
    editarColeta: false,
  });
  const [infosCriarColeta, setInfosCriarColeta] = useState({
    nomeLocal: "",
    idLocal: "",
    idOCSub: "",
    idOc: "",
    idColeta: "",
    status: "",
    infos: "",
    valorKg: "",
  });
  const [infosEditFreguesia, setInfosEditFreguesia] = useState({
    numeroOcEdit: "",
    freguesia: "",
  });
  const [linhaSelecionada, setLinhaSelecionada] = useState({
    id: "",
    status: "",
  });
  const [infosDaRota, setInfosDaRota] = useState({
    dadosRota: dadosPainelFreguesia,
    motorista: "",
    placa: "",
    levou: 0,
    volumeColetado: 0,
    pagou: 0,
    qtdColetas: 0,
    troco: 0,
    somaFornecedor: "",
  });
  const [sectionPrint, setSectionPrint] = useState({
    nomeRelatorio: null,
    idOc: null,
  });
  const [coletasRelatorio, setColetasRelatorio] = useState([]);
  const [locaisRelatorioFreguesia, setLocaisRelatorioFreguesia] = useState([]);

  const toggleSectionPrint = (nomeRelatorio, idOc) => {
    setSectionPrint({
      nomeRelatorio: null,
      idOc: null,
    });
    setTimeout(() => {
      setSectionPrint({ nomeRelatorio: nomeRelatorio, idOc: idOc });
    }, 0);
  };

  const getColetasRelatorio = async (idOc) => {
    toast.loading("Carregando coletas OC: " + idOc);
    await api
      .post(API_RELATORIO_COLETAS + idOc)
      .then((res) => {
        toast.dismiss();
        if (res.data.error === 0) {
          setColetasRelatorio(res.data.data);
          setTimeout(() => {
            window.print();
          }, 100);
          return;
        }
        toast.warn(res.data.msg);
      })
      .catch((error) => {
        console.log(error);
        toast.dismiss();
        toast.error("Algo de errado aconteceu");
      });
  };

  const getLocaisRelatorio = async (idOc) => {
    toast.loading("Carregando relatórios OC: " + idOc);
    await api
      .get(LOCAIS_ROTA + idOc)
      .then((res) => {
        toast.dismiss();
        if (res.data.error === 0) {
          setLocaisRelatorioFreguesia(res.data.data);
          setTimeout(() => {
            window.print();
          }, 100);
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((error) => {
        console.log(error);
        toast.dismiss();
        toast.error("Algo de errado aconteceu");
      });
  };

  useEffect(() => {
    if (!sectionPrint) {
      return;
    }
    if (sectionPrint.nomeRelatorio === "relatorio-coletas") {
      definirImpressaoRetrato();
      getColetasRelatorio(sectionPrint.idOc);
    } else if (sectionPrint.nomeRelatorio === "relatorio-freguesia") {
      definirImpressaoPaisagem();
      getLocaisRelatorio(sectionPrint.idOc);
    }
  }, [sectionPrint.nomeRelatorio, sectionPrint.idOc]);

  const {
    dados: dadosPainelFreguesiaOrdenado,
    ordenar: ordernarPainelFreguesia,
    ordem: ordemPainelFreguesia,
    setDados: setDadosOrdenadosPainelFreguesia,
  } = useOrdenacao(dadosPainelFreguesia, setDadosPainelFreguesia);

  const {
    dados: dadosLocaisDaRotaOrdenados,
    ordenar: ordenarLocaisDaRota,
    ordem: ordemLocaisDaRota,
    setDados: setDataLocaisOrdenados,
  } = useOrdenacao(dataLocaisFiltrados, setDataLocaisFiltrados);

  useEffect(() => {
    //Verifica se o usuario tem permissao para acessar a tela painel logistica
    verificaPermissao(idTipoUsuario, 48);
  }, []);

  function previewPage() {
    if (currentPage === 1) {
      setCurrentPage(1);
    } else {
      setCurrentPage(currentPage - 1);
    }
  }
  function nextPage() {
    if (currentPage === totalPages) {
      setCurrentPage(totalPages);
    } else {
      setCurrentPage(currentPage + 1);
    }
  }

  const getVeiculos = async () => {
    await api
      .get(API_VEICULOS)
      .then((res) => setVeiculos(res.data))
      .catch((error) => console.log(error));
  };

  const getStatus = async () => {
    await api
      .get(API_STATUS)
      .then((res) => setStatus(res.data))
      .catch((error) => console.log(error));
  };

  const getFreguesia = async () => {
    setLoading((prevState) => ({ ...prevState, loadingFreguesia: true }));
    await api
      .get(API_PAINEL_FREGUESIA + `?page=${currentPage}${filterTable}`)
      .then((res) => {
        setDadosPainelFreguesia(res.data.data);
        setDadosOrdenadosPainelFreguesia(res.data.data);
        setTotalPages(res.data.totalPages);
        setCurrentPage(res.data.currentPageNumber);
      })
      .catch((error) => {
        console.log(error);
        setDadosPainelFreguesia([]);
        Sentry.captureException(error, {
          extra: {
            response: error.response?.data.message,
            status: error.response?.status,
            url: API_PAINEL_FREGUESIA + `?page=${currentPage}${filterTable}`,
          },
        });
      })
      .finally(() =>
        setLoading((prevState) => ({ ...prevState, loadingFreguesia: false }))
      );
  };

  const carregarLocaisDaRota = async (
    id_oc,
    freguesia,
    status,
    infosDaRota
  ) => {
    setInfosDaRota({
      dadosRota: dadosPainelFreguesia,
      motorista: "",
      placa: "",
      levou: 0,
      volumeColetado: 0,
      pagou: 0,
      qtdColetas: 0,
      troco: 0,
      somaFornecedor: "",
    });
    setLoading((prevState) => ({ ...prevState, loadingLocais: true }));
    setLinhaSelecionada({ id: id_oc, status: status });
    setNumeroOc("");
    setInputFilter("");
    await api
      .get(LOCAIS_ROTA + id_oc)
      .then((res) => {
        if (res.data.error === 0) {
          setLocaisDaRota(res.data.data);
          setDataLocaisFiltrados(res.data.data);
          setFreguesia(freguesia);
          setNumeroOc(id_oc);
          setInfosCriarColeta((prevState) => ({ ...prevState, idOc: id_oc }));
          setInfosDaRota((prevState) => ({
            ...prevState,
            motorista: res.data.somas?.Motorista,
            placa: res.data.somas?.Placa,
            levou: res.data.somas?.Levou,
            troco: res.data.somas?.Troco,
            qtdColetas: res.data.somas?.QtdColeta,
            volumeColetado: res.data.somas?.VolumeColetado,
            pagou: res.data.somas?.Usou,
            somaFornecedor: res.data.somas?.SomaLocais,
          }));
          getColetasOc(id_oc);
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((error) => {
        console.log(error);
        setLocaisDaRota([]);
        Sentry.captureException(error, {
          extra: {
            response: error.response?.data.message,
            status: error.response?.status,
            url: LOCAIS_ROTA + id_oc,
          },
        });
      })
      .finally(() =>
        setLoading((prevState) => ({ ...prevState, loadingLocais: false }))
      );
  };

  // const getInfosDaRota = async (infos, locais) => {
  //   const response = await api.get(API_VIEW_EDIT + infos.IDOC);
  //   const qtdColetada = locais.reduce((acc, value) => {
  //     return acc + value.QtdColetas;
  //   }, 0);
  //   const somaVolume = locais.reduce((acc, value) => {
  //     return acc + value.SomaVolume;
  //   }, 0);
  //   const somaPagamento = locais.reduce((acc, value) => {
  //     return acc + value.SomaPagamento;
  //   }, 0);
  //   const somaFornecedor = locais.reduce((acc, value) => {
  //     return acc + value.Idlocal;
  //   }, 0);

  //   setInfosDaRota((prevState) => ({
  //     ...prevState,
  //     motorista: response?.data.data[0].Motorista,
  //     levou: response.data.data[0].ValorEntrada,
  //     qtdColetas: qtdColetada,
  //     volumeColetado: somaVolume,
  //     pagou: somaPagamento,
  //     somaFornecedor: somaFornecedor,
  //   }));
  // };

  const getColetasOc = async (id_oc) => {
    await api
      .get(API_LISTA_COLETAS_OC + id_oc)
      .then((res) => {
        if (res.data.error === 0) {
          setListaColetasOc(res.data.data);
          console.log(res.data.data);
          return;
        }
        toast.error(res.data.msgError);
      })
      .catch((error) => {
        console.log(error);
        toast.error("Algo de errado aconteceu: " + error.message);
      });
  };

  const encerrarRota = async (idOc, dataFreguesia, freguesia) => {
    confirmAlert({
      message: `Tem certeza que deseja encerrar a Freguesia ${freguesia} Nº(${idOc})?`,
      closeOnClickOutside: false,
      buttons: [
        {
          label: "Encerrar Rota",
          onClick: async () => {
            const promise = api
              .post(API_ENCERRAR_ROTA, {
                idOc,
                dataFreguesia,
              })
              .then((response) => {
                const res = response.data;
                if (res.error !== 0) {
                  throw new Error(res.msg || `Erro: ${res.error}`);
                }
                return response;
              });

            toast.promise(promise, {
              pending: "Encerrando rota...",
              success: {
                render({ data }) {
                  return data.data.msg || "Rota encerrada com sucesso!";
                },
              },
              error: {
                render({ data }) {
                  return data?.message || "Erro ao encerrar rota";
                },
              },
            });

            try {
              const response = await promise;
              getFreguesia();
              resetPainel();
            } catch (error) {
              console.error("Erro ao encerrar rota: ", error);
            }
          },
        },
        {
          label: "Fechar",
          onClick: () => {},
        },
      ],
    });
  };

  const cancelarRota = async (idOc, freguesia) => {
    CustomConfirmAlert({
      subtitle: `Tem certeza que deseja encerrar a Freguesia ${freguesia} Nº(${idOc})?`,
      labelBtnConfirmar: "Cancelar Rota",
      colorBtnConfirmar: "#f44336f7",
      onConfirm: async () => {
        const promise = api.post(API_CANCELAR_ROTA, { idOc });

        toast.promise(promise, {
          pending: "Cancelando rota...",
          success: {
            render({ data }) {
              const res = data.data;
              if (res.error === 0) {
                return res.msg || "Rota cancelada com sucesso!";
              }
              throw new Error(res.msg || `Erro: ${res.error}`);
            },
          },
          error: {
            render({ data }) {
              return data?.message || "Erro ao cancelar rota";
            },
          },
        });

        try {
          const response = await promise;
          const res = response.data;
          if (res.error === 0) {
            getFreguesia();
            resetPainel();
          }
        } catch (error) {
          console.error("Erro ao cancelar rota: ", error);
        }
      },
    });
  };

  const reativarRota = async (idOc, freguesia) => {
    confirmAlert({
      message: `Deseja reativar a Freguesia ${freguesia} Nº(${idOc})?`,
      closeOnClickOutside: false,
      buttons: [
        {
          label: "Reativar Rota",
          onClick: async () => {
            const promise = api
              .post(API_REATIVAR_ROTA + idOc)
              .then((response) => {
                const res = response.data;
                if (res.error !== 0) {
                  throw new Error(res.msg || `Erro: ${res.error}`);
                }
                return response;
              });

            toast.promise(promise, {
              pending: "Reativando rota...",
              success: {
                render({ data }) {
                  return (
                    data.data.msg || `Freguesia ${idOc} reativada com sucesso`
                  );
                },
              },
              error: {
                render({ data }) {
                  return data?.message || "Erro ao reativar freguesia";
                },
              },
            });

            try {
              const response = await promise;
              getFreguesia();
              resetPainel();
            } catch (error) {
              console.error("Erro ao reativar freguesia: ", error);
            }
          },
        },
        {
          label: "Fechar",
          onClick: () => {},
        },
      ],
    });
  };

  const resetPainel = () => {
    setInfosDaRota({
      dadosRota: dadosPainelFreguesia,
      motorista: "",
      placa: "",
      levou: 0,
      volumeColetado: 0,
      pagou: 0,
      qtdColetas: 0,
      troco: 0,
      somaFornecedor: "",
    });
    setLinhaSelecionada({ id: "", status: "" });
    setLocaisDaRota([]);
    setDataLocaisFiltrados([]);
    setListaColetasOc([]);
    setFreguesia("");
    setNumeroOc("");
  };

  const filter = (values) => {
    resetPainel();
    console.log(values);
    let data = "";
    data += `${values?.numeroOC ? `&id_oc=${values?.numeroOC}` : ""}`;
    data += `${
      values?.dataFregDe ? `&data_freguesia_de=${values?.dataFregDe}` : ""
    }`;
    data += `${
      values?.dataFregAte ? `&data_freguesia_ate=${values?.dataFregAte}` : ""
    }`;
    data += `${values?.freguesia ? `&freguesia=${values?.freguesia}` : ""}`;
    data += `${values?.veiculo ? `&id_veiculo=${values?.veiculo}` : ""}`;
    data += `${values?.status ? `&id_status=${values?.status}` : ""}`;

    setCurrentPage(1);
    setFilterTable(data);
  };

  //Filtro painel locais
  const filterLocais = (input) => {
    setInputFilter(input.toLowerCase());
    const local = locaisDaRota.filter(
      (local) =>
        // local?.IdOCSub?.toString().includes(input) ||
        local?.Logradouro?.toString().toLowerCase().includes(input) ||
        local?.Marca?.toString().toLowerCase().includes(input) ||
        local?.Codigo?.toString().toLowerCase().includes(input)
    );
    setDataLocaisFiltrados(local);
  };

  const editarColeta = (idColeta, valorKg) => {
    console.log("Valor: " + valorKg);
    setOpenModal((prev) => ({ ...prev, editarColeta: true }));
    setInfosCriarColeta((prev) => ({
      ...prev,
      idColeta: idColeta,
      valorKg: valorKg,
    }));
  };

  useEffect(() => {
    getVeiculos();
    getStatus();
  }, []);

  useEffect(() => {
    getFreguesia();
  }, [currentPage, filterTable]);

  const onOpenModalEditarFreguesia = (numeroOC, freguesia) => {
    setInfosEditFreguesia({ numeroOcEdit: numeroOC, freguesia: freguesia });
    setOpenModal((prevState) => ({ ...prevState, editarOc: true }));
  };

  const onOpenModalCriarColeta = (idlocal, idOCSub, marca, valorKg) => {
    console.log("Valor: " + valorKg);

    setInfosCriarColeta((prevState) => ({
      ...prevState,
      idLocal: idlocal,
      nomeLocal: marca,
      idOCSub: idOCSub,
      valorKg: valorKg,
    }));
    setOpenModal((prevState) => ({ ...prevState, adicionarColeta: true }));
  };

  const resetFilters = (resetForm, setFieldValue) => {
    resetForm();
    resetPainel();
    setFilterTable(`&data_freguesia_de=${diaAtual}&data_freguesia_ate=${diaAtual}`);
    setCurrentPage(1);
  };

  return (
    <Container>
      <h3>Painel de Freguesias </h3>
      <Box border={1} padding={1} marginBottom={1}>
        <Formik
          initialValues={{
            numeroOC: "",
            freguesia: "",
            dataFregDe: diaAtual,
            dataFregAte: diaAtual,
            veiculo: null,
            status: 2,
          }}
          // validationSchema={validationSchema}
          onSubmit={(values) => filter(values)}
        >
          {({ errors, touched, values, setFieldValue, resetForm }) => (
            <Form>
              <div>
                <div className={styles.filter_container}>
                  <strong>Filtros</strong>
                  <div style={{ display: "flex", gap: 10 }}>
                    <Button title="Procurar" type="submit" />
                    <Button
                      title="Limpar filtros"
                      type="button"
                      color="tertiary"
                      onClick={() => resetFilters(resetForm, setFieldValue)}
                    />
                  </div>
                </div>
                <Grid>
                  <Col size={1}>
                    <label>Nº O.C.</label>
                    <Field type="number" name="numeroOC">
                      {({ field }) => (
                        <InputClear
                          type="number"
                          onClick={() => setFieldValue("numeroOC", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.numeroOC && touched.numeroOC ? (
                      <span className={styles.alertError}>
                        {errors.numeroOC}
                      </span>
                    ) : null}
                  </Col>
                  {/* <Col size={2}>
                    <label style={{ whiteSpace: "nowrap" }}>
                      Data da Programação
                    </label>
                    <Field
                      type="date"
                      name="dataProgramacao"
                      min="1900-01-01"
                      max="9999-12-31"
                    />
                    {errors.dataProgramacao && touched.dataProgramacao ? (
                      <span className={styles.alertError}>
                        {errors.dataProgramacao}
                      </span>
                    ) : null}
                  </Col> */}
                  <Col size={2}>
                    <label style={{ whiteSpace: "nowrap" }}>
                      Data Freg. De
                    </label>
                    <Field
                      type="date"
                      name="dataFregDe"
                      min="1900-01-01"
                      max="2100-12-31"
                    />
                    {errors.dataFregDe && touched.dataFregDe ? (
                      <span className={styles.alertError}>
                        {errors.dataFregDe}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label style={{ whiteSpace: "nowrap" }}>
                      Data Freg. Ate
                    </label>
                    <Field
                      type="date"
                      name="dataFregAte"
                      min="1900-01-01"
                      max="2100-12-31"
                    />
                    {errors.dataFregAte && touched.dataFregAte ? (
                      <span className={styles.alertError}>
                        {errors.dataFregAte}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={1}>
                    <label>Freguesia</label>
                    <Field type="text" name="freguesia">
                      {({ field }) => (
                        <InputClear
                          type="text"
                          onClick={() => setFieldValue("freguesia", "")}
                          {...field}
                        />
                      )}
                    </Field>
                    {errors.freguesia && touched.freguesia ? (
                      <span className={styles.alertError}>
                        {errors.freguesia}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Veiculo</label>
                    <Field
                      component={SelectSearch}
                      name="veiculo"
                      options={veiculos.map((values) => ({
                        label: values?.placa,
                        value: values?.IDVeiculo,
                      }))}
                    />
                    {errors.veiculo && touched.veiculo ? (
                      <span className={styles.alertError}>
                        {errors.veiculo}
                      </span>
                    ) : null}
                  </Col>
                  <Col size={2}>
                    <label>Status</label>
                    <Field
                      component={SelectSearch}
                      name="status"
                      options={status.map((values) => ({
                        label: values?.Status,
                        value: values?.IDStatus,
                      }))}
                    />
                    {errors.status && touched.status ? (
                      <span className={styles.alertError}>{errors.status}</span>
                    ) : null}
                  </Col>
                </Grid>
              </div>
            </Form>
          )}
        </Formik>
      </Box>
      <div className={styles.container_grid}>
        <div className={styles.container}>
          {dadosPainelFreguesia.length && !loading.loadingFreguesia ? (
            <div className={styles.container_table}>
              <Table
                className={styles.table}
                columns={columnsFiltros}
                onSort={ordernarPainelFreguesia}
                ordem={ordemPainelFreguesia}
                sticky
              >
                {dadosPainelFreguesiaOrdenado.map((values, index) => (
                  <tr
                    key={index}
                    onClick={() => {
                      carregarLocaisDaRota(
                        values?.IDOC,
                        values?.Freguesia,
                        values?.Status,
                        values
                      );
                      setInfosCriarColeta((prevState) => ({
                        ...prevState,
                        status: values?.Status,
                        infos: values,
                      }));
                    }}
                    style={{
                      cursor: "pointer",
                      backgroundColor:
                        linhaSelecionada.id === values?.IDOC ? "#4caf50" : "",
                    }}
                  >
                    <td className={styles.menu}>
                      <div className={styles.plus}>
                        <i class="fas fa-plus"></i>
                      </div>
                      <div className={styles.menu_locais}>
                        <ul
                          className={`${styles.menu_painel} ${styles.icons_menu_container}`}
                          style={{
                            top:
                              index > 4 &&
                              index >= dadosPainelFreguesia.length - 5
                                ? values?.Status !== "Encerrada"
                                  ? "-175px"
                                  : "-105px"
                                : "",
                          }}
                          onClick={(e) => {
                            if (values?.IDOC === linhaSelecionada.id) {
                              e.stopPropagation();
                            }
                          }}
                        >
                          <strong>
                            Freguesia: {values?.Freguesia} ({values?.IDOC})
                          </strong>
                          {values?.Status !== "Encerrada" && (
                            <>
                              <li
                                onClick={() =>
                                  onOpenModalEditarFreguesia(
                                    values?.IDOC,
                                    values?.Freguesia
                                  )
                                }
                              >
                                <i
                                  class="fas fa-pencil-alt"
                                  title="Editar rota"
                                ></i>
                                <span>Editar rota</span>
                              </li>
                              <li
                                onClick={() =>
                                  encerrarRota(
                                    values?.IDOC,
                                    values?.DataProgramacao,
                                    values?.Freguesia
                                  )
                                }
                              >
                                <i
                                  class="fas fa-check"
                                  title="Encerrar rota"
                                ></i>
                                <span>Encerrar rota</span>
                              </li>
                            </>
                          )}
                          {/* <li onClick={() => window.print()}>
                            <i
                              class="fas fa-print"
                              title="Imprimir rota freguesia"
                            ></i>
                            <span>Imprimir rota freguesia</span>
                          </li> */}
                          <li className={styles.container_edit_impressoes}>
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "4px",
                              }}
                            >
                              <i
                                class="fas fa-print"
                                title="Impressões"
                                style={{ marginRight: 4 }}
                              ></i>
                              <span>Impressões</span>
                            </div>
                            <i
                              class="fas fa-caret-right"
                              style={{ background: "none", color: "#0b813c" }}
                            ></i>
                            <ul className={styles.impressoes}>
                              <li
                                onClick={() =>
                                  toggleSectionPrint(
                                    "relatorio-freguesia",
                                    values?.IDOC
                                  )
                                }
                              >
                                <i
                                  class="fas fa-print"
                                  title="Imprimir rota freguesia"
                                ></i>
                                <div className={styles.title_impressao}>
                                  Imprimir rota freguesia
                                </div>
                              </li>
                              <li
                                onClick={() =>
                                  toggleSectionPrint(
                                    "relatorio-coletas",
                                    values?.IDOC
                                  )
                                }
                              >
                                <i
                                  class="fas fa-print"
                                  title="Imprimir recados"
                                ></i>
                                <div className={styles.title_impressao}>
                                  Imprimir Recados
                                </div>
                              </li>
                            </ul>
                          </li>
                          {values?.Status == "Encerrada" && (
                            <li onClick={() => reativarRota(values?.IDOC, values?.Freguesia)}>
                              <i
                                class="fas fa-undo"
                                title="Reativar Rota freguesia"
                              ></i>
                              <span>Reativar freguesia</span>
                            </li>
                          )}
                          {values?.Status !== "Encerrada" && (
                            <li
                              onClick={() =>
                                cancelarRota(values?.IDOC, values?.Freguesia)
                              }
                            >
                              <i
                                class="fas fa-ban"
                                title="Cancelar rota freguesia"
                                style={{ backgroundColor: "red" }}
                              ></i>
                              <span>Cancelar rota freguesia</span>
                            </li>
                          )}
                        </ul>
                      </div>
                    </td>
                    <td>{values?.IDOC}</td>
                    <td>{values?.Freguesia}</td>
                    <td>{values?.Placa}</td>
                    <td>{values?.DataProgramacao?.split("T")[0]}</td>
                    <td>{values?.Status}</td>
                  </tr>
                ))}
              </Table>
            </div>
          ) : loading.loadingFreguesia ? (
            <div className={styles.loading_container}>
              <Loading display={loading.loadingFreguesia ? "block" : "none"} />
            </div>
          ) : (
            <span className={styles.loading_container}>
              Nenhuma freguesia encontrada
            </span>
          )}
          <div className={styles.table_pagination}>
            <div className={styles.table_pagination_buttons}>
              <Button
                disabled={currentPage === 1 ? true : false}
                onClick={() => previewPage()}
              >
                <i
                  style={{ marginRight: 5 }}
                  className="fas fa-chevron-left"
                ></i>
                Voltar
              </Button>
              <span>
                {currentPage} De {totalPages}
              </span>

              <Button
                disabled={
                  currentPage === totalPages || totalPages === 0 ? true : false
                }
                onClick={() => nextPage()}
              >
                Próxima
                <i
                  style={{ marginLeft: 5 }}
                  className="fas fa-chevron-right"
                ></i>
              </Button>
            </div>
          </div>
        </div>
        <Tabs
          forceRenderTabPanel={true}
          className={`${styles.container} ${styles.container_locais}`}
        >
          <TabList style={{ margin: 0 }}>
            <div className={styles.filter_container}>
              <div>
                <Tab>Freguesia {freguesia}</Tab>
                <Tab>Coletas</Tab>
              </div>
              <div className={styles.filter_container}>
                {locaisDaRota.length && !loading.loadingLocais ? (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "5px",
                    }}
                  >
                    <span>Filtrar: </span>
                    <InputClear
                      type="text"
                      value={inputFilter}
                      style={{ width: "100px" }}
                      onChange={(e) => filterLocais(e.target.value)}
                      onClick={() => {
                        setInputFilter("");
                        setDataLocaisFiltrados(locaisDaRota);
                      }}
                    />
                  </div>
                ) : null}
                <div>
                  <span>Nº OC: </span>
                  <input
                    type="number"
                    value={numeroOc}
                    disabled
                    style={{ width: "60px" }}
                  />
                </div>
              </div>
            </div>
          </TabList>
          {/* Painel Freguesia */}
          <TabPanel style={{ height: "calc(100% - 39px)" }}>
            {dataLocaisFiltrados.length && !loading.loadingLocais ? (
              <div className={styles.container_table}>
                <Table
                  columns={columnsPainelFreguesiaLocais}
                  onSort={ordenarLocaisDaRota}
                  ordem={ordemLocaisDaRota}
                  sticky
                  style={{ minWidth: "850px" }}
                >
                  {dadosLocaisDaRotaOrdenados.map((values, index) => (
                    <tr key={values?.id_local}>
                      <td className={styles.menu}>
                        <div className={styles.plus}>
                          <i class="fas fa-plus"></i>
                        </div>
                        {linhaSelecionada.status !== "Encerrada" && (
                          <div className={styles.menu_locais}>
                            <ul
                              className={`${styles.menu_painel} ${styles.icons_menu_locais}`}
                              style={{
                                top:
                                  index > 10 &&
                                  index >= dataLocaisFiltrados.length - 5 &&
                                  !values?.IdColeta?.length
                                    ? "-100px"
                                    : index > 10 &&
                                      index >= dataLocaisFiltrados.length - 5
                                    ? "-133px"
                                    : "",
                              }}
                            >
                              <strong>{values?.Codigo}</strong>
                              {values?.IdColeta?.length ? (
                                <li className={styles.container_edit_coletas}>
                                  <div>
                                    <i
                                      class="fas fa-edit"
                                      title="Editar Coletas"
                                      style={{ marginRight: 4 }}
                                    ></i>
                                    <span>Editar Coletas</span>
                                  </div>
                                  <i class="fas fa-caret-right"></i>
                                  <ul className={styles.coletas}>
                                    {values?.IdColeta.length &&
                                      values?.IdColeta.map((coleta, index) => (
                                        <li
                                          key={index}
                                          onClick={() =>
                                            editarColeta(
                                              coleta,
                                              values?.ValorKgContrapartida
                                            )
                                          }
                                        >
                                          {coleta}
                                        </li>
                                      ))}
                                  </ul>
                                </li>
                              ) : null}
                              <li
                                onClick={() =>
                                  onOpenModalCriarColeta(
                                    values?.Idlocal,
                                    values.IdOCSub,
                                    values?.Marca,
                                    values?.ValorKgContrapartida
                                  )
                                }
                              >
                                <i
                                  class="fas fa-edit"
                                  title="Adicionar Coleta"
                                ></i>
                                <span>Adicionar Coleta</span>
                              </li>
                              <li
                                onClick={() =>
                                  setOpenModal((prevState) => ({
                                    ...prevState,
                                    adicionarFornecedor: true,
                                  }))
                                }
                              >
                                <i
                                  class="fas fa-edit"
                                  title="Adicionar Fornecedor"
                                ></i>
                                <span>Adicionar Fornecedor</span>
                              </li>
                              <li
                                onClick={() =>
                                  setOpenModal((prevState) => ({
                                    ...prevState,
                                    adicionarRecadoAFreguesia: true,
                                  }))
                                }
                              >
                                <i
                                  class="fas fa-edit"
                                  title="Adicionar Recado a freguesia"
                                ></i>
                                <span>Adicionar Recado a freguesia</span>
                              </li>
                            </ul>
                          </div>
                        )}
                      </td>
                      <td>{values?.Codigo}</td>
                      {/* <td>{values?.IdOCSub}</td>
                      <td>{values?.Idlocal}</td> */}
                      <td style={{ textAlign: "start" }}>{values?.Marca}</td>
                      <td style={{ textAlign: "start" }}>
                        {values?.Logradouro}
                      </td>
                      <td>{values?.ValorKgContrapartida?.toFixed(2)}</td>
                      <td>{values?.QtdColetas}</td>
                      <td>{values?.SomaVolume?.toFixed(1)}</td>
                      <td>{values?.SomaPagamento?.toFixed(2)}</td>
                    </tr>
                  ))}
                </Table>
              </div>
            ) : loading.loadingLocais ? (
              <div className={styles.loading_container}>
                <Loading display={loading.loadingLocais ? "block" : "none"} />
              </div>
            ) : (
              <span className={styles.loading_container}>
                Nenhuma informação para exibir
              </span>
            )}
          </TabPanel>
          {/* Painel Coletas */}
          <TabPanel style={{ height: "calc(100% - 39px)" }}>
            {listaColetasOc.length && !loading.loadingLocais ? (
              <div className={styles.container_table}>
                <Table className={styles.table} columns={columnsColetas} sticky>
                  {listaColetasOc.map((values, index) => (
                    <tr key={index}>
                      <td>{values?.IdColeta}</td>
                      <td>{values?.ColetaRecado}</td>
                      <td>{values?.Codigo}</td>
                      <td>{values?.Marca}</td>
                      <td>{values?.QTDE}</td>
                      <td>{values?.TipoPagamento}</td>
                      <td>
                        {values?.ValorPagamento
                          ? `R$ ${values?.ValorPagamento?.toFixed(2)}`
                          : ""}
                      </td>
                    </tr>
                  ))}
                </Table>
              </div>
            ) : loading.loadingLocais ? (
              <div className={styles.loading_container}>
                <Loading display={loading.loadingLocais ? "block" : "none"} />
              </div>
            ) : (
              <span className={styles.loading_container}>
                Nenhuma coleta encontrada
              </span>
            )}
          </TabPanel>
        </Tabs>
        <div>
          <Box border={1} padding={2} className={styles.box}>
            <div className={styles.container_motorista}>
              <label>
                <strong>
                  Motorista: {infosDaRota?.motorista} {infosDaRota?.placa}
                </strong>
              </label>
              <div className={styles.container_estimativa}>
                <div className={styles.container_motorista_campos}>
                  <div className={styles.filter_container}>
                    <label>Levou R$ </label>
                    <input
                      type="number"
                      value={infosDaRota.levou?.toFixed(2)}
                      disabled
                    />
                  </div>
                  <div className={styles.filter_container}>
                    <label>Pagou R$ </label>
                    <input
                      type="number"
                      value={infosDaRota.pagou?.toFixed(2)}
                      disabled
                    />
                  </div>
                  <div className={styles.filter_container}>
                    <label>Troco R$ </label>
                    <input
                      type="number"
                      value={infosDaRota.troco?.toFixed(2)}
                    />
                  </div>
                </div>
                <div className={styles.container_motorista_campos}>
                  <div className={styles.filter_container}>
                    <label>Volume Coletado</label>
                    <input
                      type="number"
                      value={infosDaRota.volumeColetado?.toFixed(2)}
                      disabled
                    />
                  </div>
                  <div className={styles.filter_container}>
                    <label>Qtd Coletas</label>
                    <input
                      type="number"
                      value={infosDaRota?.qtdColetas}
                      disabled
                    />
                  </div>
                  <div className={styles.filter_container}>
                    <label>Soma Fornecedor</label>
                    <input
                      type="text"
                      value={formatterNumber(
                        Number(infosDaRota?.somaFornecedor)
                      )}
                      // value={infosDaRota.somaFornecedor}
                      disabled
                    />
                  </div>
                </div>
              </div>
            </div>
          </Box>
        </div>
        {/* <div className={styles.container_contrapartida}>
          <Tabs forceRenderTabPanel={true} className={styles.container}>
            <TabList style={{ margin: 0 }}>
              <Tab>Contrapartida</Tab>
              <Tab>Bombonas</Tab>
              <Tab>Materiais</Tab>
            </TabList>
            
            <TabPanel style={{ height: "calc(100% - 39px)" }}>
              <div className={styles.container_table}>
                <Table columns={columnsBrinde}>
                  {dadosFreguesia.map((values) => (
                    <tr key={values?.id_local}>
                      <td>{values?.Codigo}</td>
                      <td style={{ textAlign: "left" }}>{values?.Marca}</td>
                      <td style={{ textAlign: "left" }}>
                        {values?.Logradouro}
                      </td>
                    </tr>
                  ))}
                </Table>
              </div>
            </TabPanel>
            <TabPanel>BOMBONAS</TabPanel>
            <TabPanel>MATERIAIS</TabPanel>
          </Tabs>
          <Box border={1} padding={2} className={styles.box}>
            <h3 style={{ margin: 0 }}>Estimativa O.C. :CNF-6E24</h3>
            <div className={styles.container_estimativa}>
              <div>
                <Grid>
                  <Col>
                    <label>Qtd. Coleta em Roteiro</label>
                    <input type="text" />
                  </Col>
                </Grid>
                <Grid>
                  <Col>
                    <label>Qtd. Coleta Realizada</label>
                    <input type="text" />
                  </Col>
                </Grid>
                <Grid>
                  <Col>
                    <label>Qtd. Ocorrêncnia</label>
                    <input type="text" />
                  </Col>
                </Grid>
                <Grid>
                  <Col>
                    <label>Qtd. Coleta pendentes</label>
                    <input type="text" />
                  </Col>
                </Grid>
              </div>
              <div>
                <Grid>
                  <Col>
                    <label>Ligação</label>
                    <input type="text" />
                  </Col>
                </Grid>
                <Grid>
                  <Col>
                    <label>Motorista</label>
                    <input type="text" />
                  </Col>
                </Grid>
                <Grid>
                  <Col>
                    <label>Óleo Não Coletado</label>
                    <input type="text" />
                  </Col>
                </Grid>
                <Grid>
                  <Col>
                    <label>Aproveitamento(%)</label>
                    <input type="text" />
                  </Col>
                </Grid>
              </div>
            </div>
          </Box>
        </div> */}
      </div>
      <Modal
        open={openModal.editarOc}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenModal((prevState) => ({
            ...prevState,
            editarOc: false,
          }));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <EditarFreguesia
          freguesia={infosEditFreguesia.freguesia}
          numeroOC={infosEditFreguesia.numeroOcEdit}
          veiculos={veiculos}
          status={status}
          recarregaFreguesia={getFreguesia}
          closeModal={() =>
            setOpenModal((prevState) => ({ ...prevState, editarOc: false }))
          }
        />
      </Modal>
      {/* Adicionar Coleta */}
      <Modal
        open={openModal.adicionarColeta}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenModal((prevState) => ({
            ...prevState,
            adicionarColeta: false,
          }));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AdicionarColeta
          nomeLocal={infosCriarColeta.nomeLocal}
          idLocal={infosCriarColeta.idLocal}
          idOCSub={infosCriarColeta.idOCSub}
          idOc={infosCriarColeta.idOc}
          infosCriarColeta={infosCriarColeta}
          valorKg={infosCriarColeta.valorKg}
          carregarLocaisDaRota={carregarLocaisDaRota}
          freguesia={freguesia}
          closeModal={() =>
            setOpenModal((prevState) => ({
              ...prevState,
              adicionarColeta: false,
            }))
          }
        />
      </Modal>
      {/* Editar Coleta */}
      <Modal
        open={openModal.editarColeta}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenModal((prevState) => ({
            ...prevState,
            adicionarColeta: false,
          }));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AdicionarColeta
          nomeLocal={infosCriarColeta.nomeLocal}
          idLocal={infosCriarColeta.idLocal}
          idOCSub={infosCriarColeta.idOCSub}
          idOc={infosCriarColeta.idOc}
          idColeta={infosCriarColeta.idColeta}
          valorKg={infosCriarColeta.valorKg}
          freguesia={freguesia}
          infosCriarColeta={infosCriarColeta}
          carregarLocaisDaRota={carregarLocaisDaRota}
          closeModal={() =>
            setOpenModal((prevState) => ({
              ...prevState,
              editarColeta: false,
            }))
          }
        />
      </Modal>
      <Modal
        open={openModal.adicionarFornecedor}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenModal((prevState) => ({
            ...prevState,
            adicionarFornecedor: false,
          }));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AdicionarFornecedor
          freguesia={freguesia}
          IdColetasOC={infosCriarColeta.idOc}
          setLocaisDaRota={setLocaisDaRota}
          setDataLocaisFiltrados={setDataLocaisFiltrados}
          closeModal={() =>
            setOpenModal((prevState) => ({
              ...prevState,
              adicionarFornecedor: false,
            }))
          }
        />
      </Modal>
      <Modal
        open={openModal.adicionarRecadoAFreguesia}
        onClose={(event, reason) => {
          if (reason === "backdropClick" || reason === "escapeKeyDown") return;
          setOpenModal((prevState) => ({
            ...prevState,
            adicionarRecadoAFreguesia: false,
          }));
        }}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <AdicionarRecadoAFreguesia
          idOc={infosCriarColeta.idOc}
          freguesia={freguesia}
          setLocaisDaRota={setLocaisDaRota}
          setDataLocaisFiltrados={setDataLocaisFiltrados}
          closeModal={() =>
            setOpenModal((prevState) => ({
              ...prevState,
              adicionarRecadoAFreguesia: false,
            }))
          }
        />
      </Modal>

      {sectionPrint.nomeRelatorio === "relatorio-freguesia" && (
        <div id="relatorio">
          <RelatorioFreguesia
            freguesia={freguesia}
            // dia={diaDaSemana}
            table={locaisRelatorioFreguesia}
          />
        </div>
      )}

      {sectionPrint.nomeRelatorio === "relatorio-coletas" && (
        <div id="relatorio_coletas">
          {coletasRelatorio.map((coleta) => (
            <RelatorioColetas
              key={coleta?.IDColeta}
              codigo={coleta?.IDColeta}
              data={coleta?.DataPedido}
              contato={coleta?.NomeContato}
              empresa={coleta?.Marca}
              endereco={coleta?.Endereco}
              motorista={coleta?.NomeMotorista}
              observacao={coleta?.ObsColeta}
              pagamento={coleta?.FormaPagamento}
              telefones={coleta?.Telefones}
              tipoColeta={coleta?.TipoColeta}
            />
          ))}
        </div>
      )}
    </Container>
  );
}

export default PainelLogistica;
